import styles from "../../constants/assets/variables";

const tableListStyles = {
  tableContainer: {
    height: "100%",
    overflowY: "scroll",
  },
  table: {
    minWidth: 650,
    padding: "240px",
  },
  header: {
    fontWeight: 900,
  },
  tableHeadRow: {
    backgroundColor: styles.secondaryColor,
  },
  tableBodyRow: {
    "&:nth-child(even)": {
      backgroundColor: styles.TableHeadBackground,
    },
  },
  editOptions: {
    color: styles.blue500,
    textDecoration: "underline",
    "&:hover": {
      textDecoration: "none",
    },
  },
  link: {
    color: styles.primaryColor,
  },
};

const pill = {
  backgroundColor: styles.secondaryColor,
  padding: "2px 6px",
  borderRadius: "4px",
};

const actionBar = {
  marginLeft: "auto",
  marginRight: 0,
  maxWidth: "270px",
};

const fileUploadButton = {
  fileInput: {
    visibility: "hidden",
  },
  uploadButton: {
    maxWidth: "300px",
    padding: "10px",
    marginRight: "10px",
  },
  fileName: {
    color: styles.primaryColor,
  },
};
export default { tableListStyles, pill, actionBar, fileUploadButton };
